import { PropsWithChildren } from 'react';

type TabPanelProps = PropsWithChildren<{ name: string }>;

const TabPanel = ({ children }: TabPanelProps) => <>{children}</>;

export default TabPanel;
